import produce from 'immer';
import {PROFILE_DATA,LOADER_STATUS,RESPONSE_MESSAGE,SET_RADIO_VAL,RESPONSE_MULTIPLE_MESSAGE} from './constants';


export const initialState = {
    loaderStatus: false,
    msg: '',
    status: false,
    profileData: [],
    error: 0,
    radioVal: "EINV",
    eInvResultMsg: '',
    ewbResultMsg:'',
    gstResultMsg:'',
    b2cResultMsg:''
  };


  const profileManagementReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case PROFILE_DATA:
        return {
          ...state,
          profileData:action.profileData
        }
      case RESPONSE_MESSAGE:
        return {
          ...state,
          msg:action.msg,
          status:action.status,
          error:action.error
        }
      case SET_RADIO_VAL:
        return {
          ...state,
          radioVal:action.radioVal
        }
        case RESPONSE_MULTIPLE_MESSAGE:
          return {
            ...state,
            eInvResultMsg:action.eInvResultMsg,
            ewbResultMsg:action.ewbResultMsg,
            gstResultMsg:action.gstResultMsg,
            b2cResultMsg:action.b2cResultMsg,
            status:action.status,
            error:action.error
          }
        default:
          return state; 
    }
  };

export default profileManagementReducer;